// UI strings for the Blog index and article pages (ES/EN/SK).
export const BLOG_I18N = {
  es: {
    eyebrow: "Insights · Academia RE₿EL",
    index_title: "Blog RE₿EL — Trading, Bitcoin y Cripto sin humo",
    index_subtitle:
      "Guías largas, sin clickbait, escritas por traders. Cada artículo cubre un concepto a fondo: fundamentos, estrategia, técnica y psicología.",
    read_more: "Leer artículo",
    min_read: "min de lectura",
    back_to_blog: "Volver al blog",
    written_by: "Escrito por",
    published: "Publicado",
    related_label: "Sigue leyendo",
    cta_title: "¿Listo para pasar de la teoría a la práctica?",
    cta_text:
      "Las 51 lecciones de la Academia RE₿EL más el RE₿EL Market Simulator™. Acceso de por vida desde 39,90 €.",
    cta_btn_academy: "Explorar Academia",
    cta_btn_simulator: "Probar Market Simulator",
    categories: {
      fundamentos: "Fundamentos",
      inversion: "Inversión",
      estrategia: "Estrategia",
      psicologia: "Psicología",
      "analisis-tecnico": "Análisis Técnico",
    },
    disclaimer:
      "Contenido educativo. No constituye asesoramiento financiero ni recomendación de inversión.",
  },
  en: {
    eyebrow: "Insights · RE₿EL Academy",
    index_title: "RE₿EL Blog — Trading, Bitcoin & Crypto without the noise",
    index_subtitle:
      "Long, no-clickbait guides written by traders. Each article covers a concept in depth: fundamentals, strategy, technicals and psychology.",
    read_more: "Read article",
    min_read: "min read",
    back_to_blog: "Back to blog",
    written_by: "Written by",
    published: "Published",
    related_label: "Keep reading",
    cta_title: "Ready to move from theory to practice?",
    cta_text:
      "51 RE₿EL Academy lessons plus the RE₿EL Market Simulator™. Lifetime access from €39.90.",
    cta_btn_academy: "Explore Academy",
    cta_btn_simulator: "Try Market Simulator",
    categories: {
      fundamentos: "Fundamentals",
      inversion: "Investing",
      estrategia: "Strategy",
      psicologia: "Psychology",
      "analisis-tecnico": "Technical Analysis",
    },
    disclaimer:
      "Educational content. Not financial advice nor an investment recommendation.",
  },
  sk: {
    eyebrow: "Insights · RE₿EL Akadémia",
    index_title: "RE₿EL Blog — Trading, Bitcoin & Krypto bez šumu",
    index_subtitle:
      "Dlhé, neclickbait návody písané tradermi. Každý článok pokrýva koncept do hĺbky: základy, stratégia, technická analýza, psychológia.",
    read_more: "Čítať článok",
    min_read: "min čítania",
    back_to_blog: "Späť na blog",
    written_by: "Napísal",
    published: "Publikované",
    related_label: "Pokračuj v čítaní",
    cta_title: "Pripravený prejsť od teórie k praxi?",
    cta_text:
      "51 lekcií RE₿EL Akadémie plus RE₿EL Market Simulator™. Doživotný prístup od 39,90 €.",
    cta_btn_academy: "Preskúmať Akadémiu",
    cta_btn_simulator: "Skúsiť Market Simulator",
    categories: {
      fundamentos: "Základy",
      inversion: "Investovanie",
      estrategia: "Stratégia",
      psicologia: "Psychológia",
      "analisis-tecnico": "Technická analýza",
    },
    disclaimer:
      "Vzdelávací obsah. Nie je to finančné poradenstvo ani investičné odporúčanie.",
  },
  "zh-CN": {
    eyebrow: "Insights · Academia RE₿EL",
    index_title: "RE₿EL博客 — 交易、比特币与加密货币，无烟雾弹",
    index_subtitle: "深度指南，无标题党，由交易者撰写。每篇文章深入探讨一个概念：基础知识、策略、技术和心理。",
    read_more: "阅读文章",
    min_read: "分钟阅读",
    back_to_blog: "返回博客",
    written_by: "作者",
    published: "发布于",
    related_label: "继续阅读",
    cta_title: "准备好从理论走向实践了吗？",
    cta_text: "Academia RE₿EL的51节课程，外加RE₿EL Market Simulator™。终身访问权限，起价39.90欧元。",
    cta_btn_academy: "探索学院",
    cta_btn_simulator: "试用Market Simulator",
    categories: {
      fundamentos: "基础知识",
      inversion: "投资",
      estrategia: "策略",
      psicologia: "心理",
      "analisis-tecnico": "技术分析",
    },
    disclaimer: "教育内容。不构成财务建议或投资建议。",
  },
  de: {
    eyebrow: "Insights · Academia RE₿EL",
    index_title: "RE₿EL Blog — Trading, Bitcoin und Krypto ohne Bullshit",
    index_subtitle: "Ausführliche Guides, kein Clickbait, geschrieben von Tradern. Jeder Artikel behandelt ein Konzept im Detail: Grundlagen, Strategie, Technik und Psychologie.",
    read_more: "Artikel lesen",
    min_read: "Min. Lesezeit",
    back_to_blog: "Zurück zum Blog",
    written_by: "Geschrieben von",
    published: "Veröffentlicht",
    related_label: "Weiterlesen",
    cta_title: "Bereit, von der Theorie zur Praxis überzugehen?",
    cta_text: "Die 51 Lektionen der RE₿EL Academy plus RE₿EL Market Simulator™. Lebenslanger Zugang ab 39,90 €.",
    cta_btn_academy: "Academy erkunden",
    cta_btn_simulator: "Market Simulator testen",
    categories: {
      fundamentos: "Grundlagen",
      inversion: "Investment",
      estrategia: "Strategie",
      psicologia: "Psychologie",
      "analisis-tecnico": "Technische Analyse",
    },
    disclaimer: "Bildungsinhalte. Stellt keine Finanzberatung oder Anlageempfehlung dar.",
  },
};

export const getBlogI18n = (lang) => BLOG_I18N[lang] || BLOG_I18N.es;
